// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".popular-news-module__container--2ubEE{padding:20px 15px 25px;background-color:#f6f6f6;margin-bottom:20px}.popular-news-module__item--3AwRF{width:100%;margin-bottom:15px;padding-bottom:15px;border-bottom:1px solid #e2e2e2}.popular-news-module__item--3AwRF:last-child{margin-bottom:0}.popular-news-module__list--2aoa4{margin-bottom:15px}.popular-news-module__title--JK7j9{margin-bottom:20px}.popular-news-module__itemTitle--ea0Cb{color:#212121;word-break:break-word}.popular-news-module__itemTitle--ea0Cb:hover,.popular-news-module__more--5HCCZ{color:#1e54b7}", ""]);
// Exports
exports.locals = {
	"container": "popular-news-module__container--2ubEE",
	"item": "popular-news-module__item--3AwRF",
	"list": "popular-news-module__list--2aoa4",
	"title": "popular-news-module__title--JK7j9",
	"itemTitle": "popular-news-module__itemTitle--ea0Cb",
	"more": "popular-news-module__more--5HCCZ"
};
module.exports = exports;
